import { QueryClient } from '@tanstack/react-query';

// Client TanStack Query partagé. Remplace progressivement les slices Redux
// d'état serveur (contacts, applications, tasks, events, …).
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 min : évite les refetch incessants comme l'ancien flag alreadyFetched
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

export default queryClient;
